import { RouterProvider } from "react-router-dom";

// project imports
import router from "routes";
import ThemeCustomization from "themes";

import Snackbar from "components/@extended/Snackbar";
import Locales from "components/Locales";
import RTLLayout from "components/RTLLayout";
import ScrollTop from "components/ScrollTop";
import Notistack from "components/third-party/Notistack";
import QueryProvider from "~/common/components/providers/QueryProvider";
import { AzureEntraWrapper } from "~/modules/auth/azureEntra";

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <>
      <ThemeCustomization>
        <RTLLayout>
          <Locales>
            <ScrollTop>
              <AzureEntraWrapper>
                <QueryProvider>
                  <Notistack>
                    <RouterProvider router={router} />
                    <Snackbar />
                  </Notistack>
                </QueryProvider>
              </AzureEntraWrapper>
            </ScrollTop>
          </Locales>
        </RTLLayout>
      </ThemeCustomization>
    </>
  );
}
